import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller } from 'react-hook-form';
import { FormControlLabel, TextField as MuiTextField } from '@mui/material';
import HelperText from './HelperText';
const TextField = ({ control, name, label, required, autocomplete, }) => (_jsx(Controller, { name: name, control: control, render: ({ field: { onChange, onBlur, value, }, fieldState: { isTouched, error, }, }) => (_jsxs(_Fragment, { children: [_jsx(FormControlLabel, { label: label, labelPlacement: "top", control: (_jsx(MuiTextField, { fullWidth: true, name: name, onBlur: onBlur, onChange: onChange, error: isTouched && !!error, 
                    // helperText={error?.message}
                    required: required, value: value, variant: "outlined", InputLabelProps: {
                        sx: { color: (t) => (t.portal.global.font.color) },
                    }, InputProps: {
                        sx: {
                            '& fieldset': {
                                borderColor: (t) => (t.portal.global.font.color),
                            },
                        },
                    }, autoComplete: autocomplete })) }), _jsx(HelperText, { name: name, error: isTouched && error?.message })] })) }));
TextField.defaultProps = {
    required: false,
    autocomplete: 'off',
};
export default TextField;
//# sourceMappingURL=TextField.js.map